/* eslint-disable no-unused-vars */

import axios from "axios";
import { Delete, Get, Post, PostFormData } from "../Request";
export default {
  state: {
    Membership: [],
    MembershipInvoicesByUserId:[],
    membershipByUserId: [],
  },
  getters: {
    getMembershipByUserId(state) {
      return state.membershipByUserId;
    },
    getMembership(state) {
      return state.Membership;
    },
    getMembershipInvoicesByUserId(state) {
      return state.MembershipInvoicesByUserId;
    },
  },
  actions: {
    async getMembership({ commit }, payload) {
      return await Get("Membership/GetMemberships").then((res) => {
        commit("setMembership", res.data.Data);
        return res.data;
      });
    },
    async GetMembershipInvoicesByUserId({ commit }, payload) {
      return await Get(
        `Invoices/GetMembershipInvoicesByUserId/${payload.ID}`
      ).then((res) => {
        commit("SetMembershipInvoicesByUserId", res.data);
        return res.data;
      });
    },
    async DeleteMembershipInvoice({ commit }, payload) {
      return await Delete(`Invoices/DeleteMembershipInvoice/${payload}`).then((res) => {
        return res.data;
      });
    },
    async GetMembershipByUserId({ commit }, payload) {
      return await Get(
        `Membership/GetMembershipByUserId?userId=${payload.id}`
      ).then((res) => {
        commit("SetMembershipByUserId", res.data.Data);
        return res.data;
      });
    },
  },
  mutations: {
    SetMembershipByUserId(state, payload) {
      state.membershipByUserId = payload;
    },
    SetMembershipInvoicesByUserId(state, payload) {
      state.MembershipInvoicesByUserId = payload;
    },
    setMembership(state, payload) {
      state.Membership = payload;
    },
  },
};
